import type transform from '../to/exceptions';

export default (exceptions: ReturnType<typeof transform>) => {
  if (exceptions.length != new Set(exceptions.map(x => x.id)).size)
    throw new Error('(Core::From::V2::exceptions) exceptions array have two or more exceptions with the same ID');

  return exceptions
    .map(x => {
      if (!x.id)
        throw new Error('(Core::From::V2::exceptions) Calendar exceptions id is undefined');

      return { ...x };
    });
};
